import MvAddressSelectorSDKOptions from "models/MvAddressSelectorSDKOptions";

export const getPricePerAddress = (
    addressCount: number,
    options: MvAddressSelectorSDKOptions,
): number => {
    if (options?.pricePerAddress !== undefined) {
        return options.pricePerAddress || 0;
    }

    if (options?.tieredPrices !== undefined) {
        for (
            let index = options.tieredPrices.length - 1;
            index >= 0;
            index -= 1
        ) {
            const tier = options.tieredPrices[index];
            if (addressCount >= tier.min) {
                return tier.pricePerAddress;
            }
        }
    }

    return 0;
};
